export const SYNC_ERROR_DIALOG = {
    dialogId: 'SYNC_ERROR',
    dialogTitle: 'Sync Error',
    dialogMessage: 'Some of your appointment information did not sync successfully.',
    showOkButton: true,
    okButtonText: 'Sync',
    showCancelButton: false,
};

export const CONNECTION_RESTORED_DIALOG = {
    dialogId: 'CONNECTION_RESTORED',
    dialogTitle: 'Connection Restored',
    dialogMessage: 'Your internet connection is available again. We recommend syncing to keep your data up to date.',
    showOkButton: true,
    okButtonText: 'Sync',
    showCancelButton: false,
};

export const TOKEN_EXPIRED_DIALOG = {
    dialogId: 'TOKEN_EXPIRED',
    dialogTitle: 'Session Expired',
    dialogMessage: 'Your session has expired. Please reload to continue.',
    showOkButton: true,
    okButtonText: 'Reload',
    showCancelButton: false,
};

export const ENABLE_SYNC_ERROR_MODAL = true;
export const ENABLE_CONNECTION_RESTORED_MODAL = true;
export const ENABLE_TOKEN_EXPIRED_MODAL = true;

export const MAX_ATTEMPTS = 3;
export const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes
export const STORAGE_KEY = 'syncErrorAttempts';
